export default "__VITE_ASSET__ZF4YK7qmD2_wVKpRILxWJw__"